import { AppState } from 'lib/types/global';

import { NotificationsState } from './reducer';

const getState = (state: AppState): NotificationsState => state.notifications;

export const getNotifications = (state: AppState) =>
  getState(state).notifications;
